"use strict";

import dispatcher from "./../dispatcher";

import {Collection} from "vwa/flux";

import openedDetailsStore from "./openedDetails";

const vehiclePOICrossingStore = new Collection({keyNames: ["vehicle"]});
export default vehiclePOICrossingStore;

window.vehiclePOICrossingStore = vehiclePOICrossingStore;

function createStoreItemFromActivity(report, from, to) {
	return {
		vehicle:				report.options.carrier,
		options:				report.options,
		result:					report.result,
		pinnedCrossings:		createPinnedCrossingsSet(report.result.summaries.pois),
		highlightedCrossing:	null
	};
}

function createPinnedCrossingsSet(poiSummaries){
	const pinnedCrossings = new Set();
	poiSummaries.forEach(poiSummary => pinnedCrossings.add(poiSummary.poi));
	return pinnedCrossings;
}

dispatcher.on('clearVehiclePOICrossings', vehicleId => {
	vehiclePOICrossingStore.remove([vehicleId]);
});

dispatcher.on('getVehiclePOICrossings', (report, from, to) => {
	const prevActivity = vehiclePOICrossingStore.get(report.options.carrier);
	if (prevActivity)
		vehiclePOICrossingStore.update(report.options.carrier, createStoreItemFromActivity(report, from, to));
	else
		vehiclePOICrossingStore.insert([createStoreItemFromActivity(report, from, to)]);
});

dispatcher.on("highlightVehiclePOICrossing", (vehicleId, time) => {
	const poiCrossings = vehiclePOICrossingStore.get(vehicleId);
	poiCrossings.highlightedCrossing = time;
	vehiclePOICrossingStore.update(vehicleId, poiCrossings);
});

dispatcher.on("unhighlightVehiclePOICrossing", (vehicleId) => {
	const poiCrossings = vehiclePOICrossingStore.get(vehicleId);
	poiCrossings.highlightedCrossing = null;
	vehiclePOICrossingStore.update(vehicleId, poiCrossings);
});

dispatcher.on("pinVehiclePOICrossingsOfPOI", (vehicleId, pois, value) => {
	const poiCrossings = vehiclePOICrossingStore.get(vehicleId);
	pois.forEach(
		poi => {
			if(value){
				poiCrossings.pinnedCrossings.add(poi);
			}
			else{
				poiCrossings.pinnedCrossings.delete(poi);
			}
		}
	);
	vehiclePOICrossingStore.update(vehicleId, poiCrossings);
});

openedDetailsStore.on('remove', descriptors => {
	vehiclePOICrossingStore.remove(descriptors.map(descriptor => descriptor.id));
});

dispatcher.on("logout", () => {
	vehiclePOICrossingStore.set(null);
});


// WEBPACK FOOTER //
// ./src/store/vehiclePOICrossings.js